module.exports = __webpack_public_path__ + "img/p93.6ffc7ebf.png";